// extracted by mini-css-extract-plugin
export default {"root":"Main-root_a40mS"};